'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') return Component;
  if (!Component) return undefined;

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;
//# sourceMappingURL=get-display-name.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-sizes/lib/utils/get-display-name.js
// module id = 836
// module chunks = 0